import { DoDontContainer, Do, Dont, Caption } from '@primer/gatsby-theme-doctocat';
import * as React from 'react';
export default {
  DoDontContainer,
  Do,
  Dont,
  Caption,
  React
};